import React from 'react'
import { PageHeaderProps } from 'antd/lib/page-header'

import { useT } from 'src/core/hooks/use-translation'
import HamburgerMenu from 'src/layouts/Dashboard/components/hamburger-menu'

import { WrapContent, WrapHamburgermenu, WrapPageHeader } from './styles'

function PageHeader({ ghost = false, title, ...props }: PageHeaderProps) {
  const { t } = useT()

  return (
    <WrapContent>
      <WrapHamburgermenu>
        <HamburgerMenu />
      </WrapHamburgermenu>
      <WrapPageHeader {...props} ghost={ghost} title={t(title)} />
    </WrapContent>
  )
}

export default PageHeader
